export enum FieldType {
    INPUT = "input",
    SELECT = "select",
    TEXTAREA = "textarea",
    CHECKBOX = "checkbox",
    RADIO = "radio",
    DATE = "date",
    FILE = "file",
    PAGINATED_SELECT = "paginated_select",
    SHOW = "show" // for showing on the list (data table) only not on the form
}